<template>
    <el-dialog title="选择出库产品" :visible.sync="selectProductTransferDialog" width="620px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_select_code_wrap">
            <div class="product_select_code_top">
                <el-input size="small" v-model="keywords" placeholder="请输入产品名称"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                    <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                </el-input>
            </div>
            <div class="product_select_code_bottom">
                <el-table class="custom_table" :data="tableData" border height="477px" ref="multipleTable" row-key="id"  >
                    <el-table-column label="产品名称" prop="name" show-overflow-tooltip min-width="285px"></el-table-column>
                    <el-table-column label="库存数量" prop="total_num" align="right" show-overflow-tooltip width="85px"></el-table-column>
                    <el-table-column label="操作" prop="handle" align="center" show-overflow-tooltip width="65px">
                        <template slot-scope="{row,$index}">
                            <el-button :disabled="selectData.find(find =>find.name == row.name) ? true : false" type="text" @click="handleDialogConfirm(row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="product_select_code_pagination">
                <el-pagination background
                               size="mini"
                               @size-change="handleSizeChange"
                               @current-change="handleCurrentChange"
                               :current-page="pagination.pageNum"
                               :page-sizes="pagination.pageSizes"
                               :page-size="pagination.pageSize"
                               :layout="pagination.layout"
                               :pager-count="5"
                               :total="pagination.total">
                </el-pagination>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { stockProductList } from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "select_product_transfer",
    props: {
        selectProductTransferDialog: {
            type: Boolean,
            default: false
        },
        warehouseId: {
            type: Number,
            default: 0
        },
        selectData:{
            type:Array,
            default:() => []
        }
    },
    data() {
        return {
            keywords:'',
            BtnDisabled:false,
            tableData:[],
        }
    },
    mixins: [pagination],
    created() {
        this.getTableData()

    },
    methods: {
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },

        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                id:this.warehouseId ? this.warehouseId : '',
                keyword:this.keywords
            }
            this.loading = true
            stockProductList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:selectProductTransferDialog", false)
        },
        handleDialogConfirm(row) {
            this.$emit("success", row)
            this.$emit("update:selectProductTransferDialog", false)
        },

    }
}
</script>
<style  lang="scss" scoped>
::v-deep .el-pagination__jump{
    display: none !important;
}
@import "@/styles/inventory_management.scss";
</style>